import {Suspense, lazy} from 'react';
import {useTranslation} from 'react-i18next';
import {Smartphone} from 'lucide-react';
import {Skeleton} from '@chekinapp/ui';
import {useIVIntent} from 'hooks/iv/ivIntent';
import {useIVRemoteHandoffStore} from 'hooks/iv/useIVRemoteHandoff';
import {useRemoteStartVerificationLink} from 'hooks/iv/useRemoteStartVerificationLink';
import {QR_MAX_SIZE} from '../fit/velaFit';

const QR_SIZE_CLASS = 'size-[var(--vela-qr-size,120px)]';

const QRCodeSVG = lazy(() =>
  import('qrcode.react').then(module => ({default: module.QRCodeSVG})),
);

export function VelaPhoneHandoff() {
  const {t} = useTranslation('vela');
  const {generateRemoteStartVerificationLink} = useRemoteStartVerificationLink();
  const isStartedOnMobile = useIVRemoteHandoffStore(state => state.isStartedOnMobile);
  const intentId = useIVIntent(!isStartedOnMobile);

  if (isStartedOnMobile) {
    return (
      <div className="flex items-start gap-2.5 rounded-[12px] bg-[var(--chekin-success-surface)] p-3">
        <Smartphone className="mt-px size-4 flex-none text-[var(--chekin-success-text)]" />
        <div className="min-w-0">
          <p className="text-[13px] font-semibold text-[var(--chekin-success-text)]">
            {t('handoff.connected_title')}
          </p>
          <p className="mt-0.5 text-[12px] leading-[17px] text-[var(--assistant-tip-description)]">
            {t('handoff.connected_body')}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-[18px]">
      <div className="min-w-0 pt-px">
        <p className="text-[13px] font-bold text-[var(--assistant-tip-title)]">
          {t('handoff.title')}
        </p>
        <p className="mt-0.5 text-[12px] leading-[17px] text-[var(--assistant-tip-description)]">
          {t('handoff.body')}
        </p>
      </div>

      <div data-vela-qr className="self-center">
        <Suspense fallback={<Skeleton className={QR_SIZE_CLASS} />}>
          {intentId ? (
            <QRCodeSVG
              value={generateRemoteStartVerificationLink()}
              size={QR_MAX_SIZE}
              className={QR_SIZE_CLASS}
            />
          ) : (
            <Skeleton className={QR_SIZE_CLASS} />
          )}
        </Suspense>
      </div>
    </div>
  );
}
